document.addEventListener('DOMContentLoaded', () => {
    const blogListingSection = document.querySelector('.blog-listing');
    if (!blogListingSection) return;

    if (blogListingSection.dataset.initialized === 'true') {
        return;
    }
    blogListingSection.dataset.initialized = 'true';

    const tagFilterTabs = blogListingSection.querySelectorAll('[data-tag-filter]');
    const articlesListing = document.getElementById('articles-listing');
    const paginationContainer = document.getElementById('blog-pagination');
    const featuredArticleContainer = blogListingSection.querySelector('.featured-article');
    const sectionId = 'blog-listing';

    let currentTagFilter = '';
    let currentPage = 1;
    let isFetching = false;

    function showLoading() {
        if (articlesListing) {
            articlesListing.classList.add('opacity-50', 'pointer-events-none');
        }
    }

    function hideLoading() {
        if (articlesListing) {
            articlesListing.classList.remove('opacity-50', 'pointer-events-none');
        }
    }

    function scrollTabIntoView(tab) {
        const tabsContainer = document.getElementById('blog-tag-tabs');
        if (!tabsContainer) return;

        const containerRect = tabsContainer.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();

        const isFullyVisible =
            tabRect.left >= containerRect.left &&
            tabRect.right <= containerRect.right;

        if (!isFullyVisible) {
            tab.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
            });
        }
    }

    async function fetchBlogSection(tag = '', page = 1, updateUrl = true) {
        if (isFetching) return;

        isFetching = true;
        showLoading();

        try {
            const url = new URL(window.location.origin + window.location.pathname);
            url.searchParams.set('sections', sectionId);

            if (tag && tag !== 'all') {
                url.searchParams.set('tag', tag);
            } else {
                url.searchParams.delete('tag');
            }

            if (page && page > 1) {
                url.searchParams.set('page', page.toString());
            } else {
                url.searchParams.delete('page');
            }

            const response = await fetch(url.toString());
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseData = await response.json();
            let sectionHTML = responseData[sectionId] || responseData['blog-listing'] || '';

            if (!sectionHTML && Object.keys(responseData).length > 0) {
                const firstKey = Object.keys(responseData)[0];
                sectionHTML = responseData[firstKey];
            }

            if (!sectionHTML) {
                throw new Error('No section data returned');
            }

            const domParser = new DOMParser();
            const doc = domParser.parseFromString(sectionHTML, 'text/html');
            const newBlogListing = doc.querySelector('.blog-listing');

            if (newBlogListing) {
                // Replace featured article
                const newFeaturedArticle = newBlogListing.querySelector('.featured-article');
                const currentFeaturedArticle = blogListingSection.querySelector('.featured-article');
                if (newFeaturedArticle && currentFeaturedArticle) {
                    currentFeaturedArticle.replaceWith(newFeaturedArticle);
                } else if (newFeaturedArticle && !currentFeaturedArticle) {
                    const tagTabs = blogListingSection.querySelector('#blog-tag-tabs');
                    if (tagTabs) {
                        tagTabs.after(newFeaturedArticle);
                    } else {
                        const articlesList = document.getElementById('articles-listing');
                        if (articlesList) {
                            articlesList.before(newFeaturedArticle);
                        }
                    }
                } else if (!newFeaturedArticle && currentFeaturedArticle) {
                    currentFeaturedArticle.remove();
                }

                // Replace articles listing
                const newArticlesListing = newBlogListing.querySelector('#articles-listing');
                const currentArticlesListing = document.getElementById('articles-listing');
                if (newArticlesListing && currentArticlesListing) {
                    currentArticlesListing.replaceWith(newArticlesListing);
                }

                // Replace pagination
                const newPagination = newBlogListing.querySelector('#blog-pagination');
                const currentPagination = document.getElementById('blog-pagination');
                if (newPagination) {
                    if (currentPagination) {
                        currentPagination.replaceWith(newPagination);
                    } else {
                        const articlesAfter = document.getElementById('articles-listing');
                        if (articlesAfter && articlesAfter.parentElement) {
                            articlesAfter.parentElement.appendChild(newPagination);
                        }
                    }
                } else if (currentPagination) {
                    currentPagination.remove();
                }

                // Update tag tabs state
                const newTabsContainer = newBlogListing.querySelector('#blog-tag-tabs');
                const currentTabsContainer = document.getElementById('blog-tag-tabs');

                if (newTabsContainer && currentTabsContainer) {
                    const newTabs = newTabsContainer.querySelectorAll('[data-tag-filter]');
                    const currentTabs = currentTabsContainer.querySelectorAll('[data-tag-filter]');

                    newTabs.forEach((newTab, index) => {
                        if (currentTabs[index]) {
                            const isActive = newTab.getAttribute('data-tag-active') === 'true';
                            if (isActive) {
                                currentTabs[index].classList.remove('bg-white', 'text-black', 'hover:bg-gray-100');
                                currentTabs[index].classList.add('bg-black', 'text-white');
                                currentTabs[index].setAttribute('data-tag-active', 'true');
                            } else {
                                currentTabs[index].classList.remove('bg-black', 'text-white');
                                currentTabs[index].classList.add('bg-white', 'text-black', 'hover:bg-gray-100');
                                currentTabs[index].setAttribute('data-tag-active', 'false');
                            }
                        }
                    });
                }

                // Re-setup pagination listeners after DOM replacement
                setupPaginationListeners();

                // Scroll to top of listings
                const articlesAfter = document.getElementById('articles-listing');
                if (articlesAfter) {
                    articlesAfter.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }

            // Update URL
            if (updateUrl) {
                const urlParams = new URLSearchParams(window.location.search);
                if (tag && tag !== 'all') {
                    urlParams.set('tag', tag);
                } else {
                    urlParams.delete('tag');
                }
                if (page && page > 1) {
                    urlParams.set('page', page.toString());
                } else {
                    urlParams.delete('page');
                }
                const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
                window.history.pushState({}, '', newUrl);
            }

            currentTagFilter = tag || '';
            currentPage = page || 1;
        } catch (error) {
            console.error('Error fetching blog section:', error);
        } finally {
            isFetching = false;
            hideLoading();
        }
    }

    function setupPaginationListeners() {
        const paginationLinks = document.querySelectorAll('[data-pagination-link]');
        paginationLinks.forEach((link) => {
            if (link.dataset.listenerAttached === 'true') {
                return;
            }
            link.dataset.listenerAttached = 'true';

            link.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const page = parseInt(this.dataset.page) || 1;
                fetchBlogSection(currentTagFilter, page);
            });
        });
    }

    tagFilterTabs.forEach((tab) => {
        if (tab.dataset.listenerAttached === 'true') {
            return;
        }
        tab.dataset.listenerAttached = 'true';

        tab.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const tagFilter = this.dataset.tagFilter;

            if (currentTagFilter === tagFilter && this.getAttribute('data-tag-active') === 'true') {
                return;
            }

            currentTagFilter = tagFilter;

            tagFilterTabs.forEach((t) => {
                if (t === this) {
                    t.classList.remove('bg-white', 'text-black', 'hover:bg-gray-100');
                    t.classList.add('bg-black', 'text-white');
                    t.setAttribute('data-tag-active', 'true');
                    return;
                }
                t.classList.remove('bg-black', 'text-white');
                t.classList.add('bg-white', 'text-black', 'hover:bg-gray-100');
                t.setAttribute('data-tag-active', 'false');
            });

            scrollTabIntoView(this);
            fetchBlogSection(tagFilter, 1);
        });
    });

    // Setup pagination listeners
    setupPaginationListeners();

    // Initialize current state from URL
    const activeTab = Array.from(tagFilterTabs).find(
        tab => tab.getAttribute('data-tag-active') === 'true'
    );
    if (activeTab) {
        currentTagFilter = activeTab.dataset.tagFilter || '';
    }

    const urlParams = new URLSearchParams(window.location.search);
    const pageParam = urlParams.get('page');
    if (pageParam) {
        currentPage = parseInt(pageParam) || 1;
    }
});

